import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter as Router,Route,Switch,Redirect, Link} from "react-router-dom";
import { ConfigProvider } from 'antd';
import routesConfig from "./routesConfig.js";
import reportWebVitals from './reportWebVitals';
import zhCN from 'antd/es/locale/zh_CN';
import 'moment/locale/zh-cn';

import './index.scss';
import './assets/css/iconfont.css';
import './assets/css/common.scss';

const Root = routesConfig.root.Root;
const base_url = routesConfig.root.baseUrl || '/';

class RouterDom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            routeList: ["/page/search", "/page/404", "/page/read", "/page/book-list"],
        };
    }

    async componentDidMount() {}

    componentWillUnmount() {}

    getRouteList (list) {
        this.setState({
            routeList: list
        })
    }

    routeFunc (routes, baseUrl) {
        const {routeList: newRouteList} = this.state;
        let pathList = []
        let filterRoutes = routes.filter(item => {
            const path = baseUrl + item.path
            return path === '/page/404' || newRouteList.includes(path)
        })
        let routeList = filterRoutes.map(item=>{
            let dom = null;
            const path = baseUrl + item.path
            pathList.push(path)
            if (item.component) {
                dom = (<Route exact={item.exact} path={path} key={item.name} component={item.component}/>);
            } else {
                dom = (<Route exact={item.exact} path={path} key={item.name} render={item.render}/>);
            }
            return dom;
        })
        return {routeList, pathList}
    }

    render() {
        const {pathList, routeList} = this.routeFunc(routesConfig.root.routes, base_url);
        return (
            <ConfigProvider locale={zhCN}>
                <Router>
                    <Switch>
                        <Route exact path="/page/error" component={routesConfig.ErrorPage}/>
                        <Route path="/page" render={(match) => <Root match={{...match}} pathList={pathList} updateRoute={(route) => this.getRouteList(route)}>{routeList}</Root>} />
                        <Route path="/404" component={routesConfig.NotFound}/>
                        <Redirect exact from="/" to={"/page/book-list"} />
                        <Redirect from="/*" to={"/404"} />
                    </Switch>
                </Router>
            </ConfigProvider>
        );
    }
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<RouterDom />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
